import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as MaterialActions from './material.actions';
import { DisplayProductDataService } from '../../display-product-data.service';

@Injectable()
export class MaterialEffects {

  private actions$ = inject(Actions);
  private service = inject(DisplayProductDataService);

  loadMaterials$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MaterialActions.loadMaterials),
      mergeMap(() =>
        this.service.getMaterialList().pipe(
          map(data => MaterialActions.loadMaterialsSuccess({ data })),
          catchError(error =>
            of(MaterialActions.loadMaterialsFailure({ error }))
          )
        )
      )
    )
  );
}